const WorkExperience = [
       {
        id: 1,
        title: "Software Development",
        company: "Freelancer",
        yearsActive: "May 2020 - Present",
        information: [
            "Write modern, performant, maintainable code for a diverse array of internal projects",
            "Communicate with multi-disciplinary teams of engineers, team leads, and QA Engineers on a daily basis",
        ],
    },
    {
        id: 2,
        title: "Software Developer",
        company: "Bluesoft",
        yearsActive: "March 2017 - May 2020",
        information: [
            "Worked to support the senior support staff with day-to-day tasks.",
            "Assisted with the evaluation and troubleshooting of software development.",
        ],
    },
];

export default WorkExperience;
